import { forwardRef, useLayoutEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { SwapFormKeyHelper } from '../../providers';
import { fitInputText } from '../../utils';
import { maxInputFontSize, minInputFontSize } from './SwapInput.style';
export const FitInputText = forwardRef(({ formType }, ref) => {
    const amountKey = SwapFormKeyHelper.getAmountKey(formType);
    const [amount] = useWatch({
        name: [amountKey],
    });
    useLayoutEffect(() => {
        fitInputText(maxInputFontSize, minInputFontSize, ref
            .current);
    }, [amount, ref]);
    return null;
});
